import { render } from "./MuseumPremialitaB.vue?vue&type=template&id=571d6d72"
import script from "./MuseumPremialitaB.vue?vue&type=script&lang=js"
export * from "./MuseumPremialitaB.vue?vue&type=script&lang=js"

import "./MuseumPremialitaB.vue?vue&type=style&index=0&id=571d6d72&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__